"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Label_1 = require("./Label");
exports.default = Label_1.default;
//# sourceMappingURL=index.js.map